import { MouseEvent } from 'react';
import ContentCopy from '@mui/icons-material/ContentCopy';
import OpenInNew from '@mui/icons-material/OpenInNew';
import { Box, IconButton, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { appToast } from 'utils/toast.utils';
import { TableData } from '../invoicesTable.types';

export const KsefActionsCell = ({
  ksefNumber,
  ksefQrLink,
}: TableData['ksefActions']) => {
  const { t } = useTranslation('invoice');

  if (!ksefNumber && !ksefQrLink) return null;

  const handleCopy = async (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    if (!ksefNumber) return;

    try {
      await navigator.clipboard.writeText(ksefNumber);
      appToast.success(t('ksefNumberCopied'));
    } catch {
      appToast.error(t('ksefNumberCopyError'));
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 0.5,
        paddingRight: 1,
      }}
    >
      {ksefQrLink && (
        <Tooltip title={t('openInKsef')} arrow>
          <IconButton
            component='a'
            href={ksefQrLink}
            target='_blank'
            rel='noopener noreferrer'
            size='small'
            aria-label={t('openInKsef')}
            onClick={(event: MouseEvent<HTMLAnchorElement>) =>
              event.stopPropagation()
            }
            sx={{ p: 0.5, color: 'text.secondary' }}
          >
            <OpenInNew sx={{ fontSize: 18 }} />
          </IconButton>
        </Tooltip>
      )}
      {ksefNumber && (
        <Tooltip
          title={
            <>
              <Box>{t('copyKsefNumber')}</Box>
              <Box sx={{ whiteSpace: 'nowrap' }}>{ksefNumber}</Box>
            </>
          }
          componentsProps={{ tooltip: { sx: { maxWidth: 'none' } } }}
          arrow
        >
          <IconButton
            size='small'
            aria-label={t('copyKsefNumber')}
            onClick={handleCopy}
            sx={{ p: 0.5, color: 'text.secondary' }}
          >
            <ContentCopy sx={{ fontSize: 18 }} />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
};
